function resolveShopifyUrl(src) {
  if (!src) return null;
  if (src.startsWith('http')) return src;
  return 'https://' + window.location.hostname + '/cdn/shop/' + src;
}

function buildSrcset(baseUrl) {
  const clean = baseUrl.split('?')[0];
  return [360, 540, 720, 900, 1080, 1366]
    .map(w => `${clean}?width=${w} ${w}w`)
    .join(', ');
}

function upgradeHoverImages(root) {
  (root || document).querySelectorAll('[data-depict-product-id]').forEach(function (card) {
    const rawUrl = card.getAttribute('data-depict-hover-image');
    if (!rawUrl || rawUrl.trim() === '') return;

    const hoverUrl = resolveShopifyUrl(rawUrl);
    if (!hoverUrl) return;

    const imageContainer = card.querySelector('.featured-collection__image');
    if (!imageContainer) return;

    if (imageContainer.querySelector('.custom-hover-img-wrap')) return;

    const oldHover = card.querySelector('.product-item-hover[data-bgset]');
    if (oldHover) oldHover.remove();

    const objectContain = imageContainer.querySelector('img[style*="contain"]') !== null;

    const wrap = document.createElement('div');
    wrap.className = 'custom-hover-img-wrap absolute top-0 left-0 bottom-0 right-0 opacity-0 z-20 transition-opacity duration-200 ease-in-out overflow-hidden pointer-events-none';

    const img = document.createElement('img');
    img.src = hoverUrl.split('?')[0] + '?width=1366';
    img.srcset = buildSrcset(hoverUrl);
    img.sizes = '(min-width: 1200px) 25vw, (min-width: 768px) 33vw, 50vw';
    img.loading = 'eager';
    img.className = 'absolute top-0 left-0 w-full h-full';
    img.style.objectFit = objectContain ? 'contain' : 'cover';
    img.onerror = function() { wrap.remove(); };

    wrap.appendChild(img);
    imageContainer.appendChild(wrap);
  });
}

// Observa DOM-ändringar
const observer = new MutationObserver(function (mutations) {
  mutations.forEach(function (m) {
    m.addedNodes.forEach(function (node) {
      if (node.nodeType === 1) upgradeHoverImages(node);
    });
  });
});

observer.observe(document.body, { childList: true, subtree: true });

// Fallback: kör upprepade gånger tills kort finns
let attempts = 0;
const interval = setInterval(function() {
  attempts++;
  upgradeHoverImages(document);
  if (document.querySelectorAll('.custom-hover-img-wrap').length > 0 || attempts > 20) {
    clearInterval(interval);
  }
}, 300);

// Hover-trigger via JavaScript
document.addEventListener('mouseover', function(e) {
  const card = e.target.closest('[data-depict-product-id]');
  if (card) {
    const wrap = card.querySelector('.custom-hover-img-wrap');
    if (wrap) wrap.style.opacity = '1';
  }
});

document.addEventListener('mouseout', function(e) {
  const card = e.target.closest('[data-depict-product-id]');
  if (card) {
    const wrap = card.querySelector('.custom-hover-img-wrap');
    if (wrap) wrap.style.opacity = '0';
  }
});